import { ResetPasswordWithTokenPage } from 'auth/pages'

export default function ResetPasswordWithToken() {
  return <ResetPasswordWithTokenPage />
}
